import React from "react";

import "./loadingSkeleton.styles.scss";

const LoadingSkeleton = (props: any) => (
  <div className="skeletonWrap">
    <div className="skeleton skeleton_1" />
    <div className="skeleton skeleton_2" />
    <div className="skeleton_section1">
      <div className="skeleton_section2">
        <div className="skeleton skeleton_3" />
        <div className="skeleton skeleton_4" />
        <div className="skeleton skeleton_5" />
      </div>
      <div className="skeleton_section3">
        <div className="skeleton skeleton_6" />
        <div className="skeleton skeleton_7" />
        <div className="skeleton skeleton_8" />
        <div className="skeleton skeleton_9" />
        <div className="skeleton skeleton_10" />
      </div>
    </div>
  </div>
);

export default LoadingSkeleton;
